import { useEffect, useState } from "react";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import GridOnIcon from "@mui/icons-material/GridOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Button from "../../atoms/Button/Button";
import RiskMapPreview from "../../molecules/RiskMapPreview/RiskMapPreview";
import "./Hero.css";
 
const stats = [
  {
    icon: <SatelliteAltIcon fontSize="inherit" />,
    label: "COUVERTURE",
    pre: "",
    value: "100%",
    unit: "FRANCE",
    note: "Aucune zone blanche",
  },
  {
    icon: <GridOnIcon fontSize="inherit" />,
    label: "PRECISION",
    pre: "",
    value: "3",
    unit: "KM",
    note: "Résolution identique sur l'ensemble du territoire",
  },
  {
    icon: <AccessTimeIcon fontSize="inherit" />,
    label: "ANTICIPATION",
    pre: "JUSQU'À",
    value: "36",
    unit: "h",
    note: "Prévenir plutôt que réagir",
  },
];
 
const Hero = () => {
  const [visible, setVisible] = useState(false);
 
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
 
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
 
  return (
    <>
      <header className="hero hero-fullscreen">
        <div className="hero-overlay" />
 
        <div className="hero-layout">
          <div className="hero-content-wrapper">
            <div className="hero-text-section">
              <div className="hero-eyebrow">
                Le climat a changé les règles. Notre technologie s'adapte au
                changement.
              </div>
 
              <h1>
                Avec la recherche, <br /> luttons tous ensemble <br />
                <span className="u">contre les feux de forêt</span>
              </h1>
 
              <div className="hero-sub-box">
                <p>
                  Surveillance météorologique continue et homogène du risque de
                  départ de feu, sur toute la France.
                </p>
                <p>
                  Prédiction horaire grâce aux données satellites pour vous
                  permettre d'anticiper les risques.
                </p>
                <p>
                  Un service gratuit, fruit d'une coopération scientifique entre
                  l'EDHEC Climate Institute et Climate Innov
                </p>
              </div>
 
              <div className="cta">
                <Button
                  label="Carte des risques de feux de forêt sur 36 heures"
                  variant="primary"
                  href="/notifications"
                />
                <Button
                  label="S'informer au quotidien"
                  variant="secondary"
                  to="/register"
                />
              </div>
 
              <div className="hero-stats">
                {stats.map((s, i) => (
                  <div className="hero-stat-item" key={i}>
                    <span className="hero-stat-icon">{s.icon}</span>
                    <span className="hero-stat-label">{s.label}</span>
                    <div className="hero-stat-value-wrapper">
                      {s.pre && <span className="hero-stat-pre">{s.pre}</span>}
                      <span className="hero-stat-value">{s.value}</span>
                      {s.unit && <span className="hero-stat-unit">{s.unit}</span>}
                    </div>
                    <span className="hero-stat-note">{s.note}</span>
                  </div>
                ))}
              </div>
            </div>
 
            <div className="hero-map-section">
              <RiskMapPreview title="" liveLabel="" />
            </div>
          </div>
        </div>
      </header>
 
      <button
        className={`scroll-to-top${visible ? " scroll-to-top--visible" : ""}`}
        onClick={scrollToTop}
        aria-label="Retour en haut de page"
      >
        <KeyboardArrowUpIcon />
      </button>
    </>
  );
};
 
export default Hero;